import React, { forwardRef, memo, useImperativeHandle, useState } from 'react';

import Input from 'components/shared/Input/Input';

const IncrementCellEditorInner = (params, ref) => {
  const { value } = params || {};
  const [inputValue, setInputValue] = useState(value);

  useImperativeHandle(
    ref,
    () => ({
      getValue: () => inputValue
    }),
    [inputValue]
  );

  const handleChange = (event) => {
    const { value } = event.target;
    setInputValue(value);
  };
  return (
    <div tabIndex={1}>
      <Input
        type="number"
        inputWrapperClassName="h-[40px] border-none !bg-transparent"
        value={inputValue}
        onChange={handleChange}
      />
    </div>
  );
};

const IncrementCellEditor = memo(forwardRef(IncrementCellEditorInner));
IncrementCellEditor.displayName = 'IncrementCellEditor';

export default IncrementCellEditor;
